import { render, staticRenderFns } from "./infoCardList.vue?vue&type=template&id=49f93819&scoped=true"
import script from "./infoCardList.vue?vue&type=script&lang=js"
export * from "./infoCardList.vue?vue&type=script&lang=js"
import style0 from "./infoCardList.vue?vue&type=style&index=0&id=49f93819&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f93819",
  null
  
)

export default component.exports